var render, staticRenderFns
import script from "./tooltipped-truncated-field.vue?vue&type=script&lang=js"
export * from "./tooltipped-truncated-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f7ef0",
  null
  
)

export default component.exports